import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DatapointFieldListEffects } from './datapoint-field-list.effects';
import { reducer } from './datapoint-field-list.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('datapointFieldList', reducer),
    EffectsModule.forFeature([DatapointFieldListEffects]),
  ],
  providers: [DatapointFieldListEffects],
})
export class DatapointFieldListStoreModule {}
